import { createContext } from "react";
import { useInfinitePlayers } from "../teams/Teams.state";

export const MonitorContext = createContext();
export const MonitorContextProvider = ({ children }) => {
    const teams = useInfinitePlayers();

    return (
        <MonitorContext.Provider value={{ teams }}>
            { children }
        </MonitorContext.Provider>
    )
}